import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceTaxSettingsAction from '../actions/ecommerce-tax-settings.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceTaxSettings} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {
    TaxSettingsMapper
} from "../../websites/website/ecommerce/ecommerce-tax/tax-settings/mapper/tax-settings-mapper";

@Injectable()
export class EcommerceTaxSettingsEffect {

  loadEcommerceTaxSettings = createEffect(() => this._actions$.pipe(
    ofType(EcommerceTaxSettingsAction.LOAD_ECOMMERCE_TAX_SETTINGS),
    mergeMap((action: LoadEcommerceTaxSettings) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getTaxSettings(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              const data = (response?.data?.dataKey).map(TaxSettingsMapper.map);
              return new EcommerceTaxSettingsAction.LoadEcommerceTaxSettingsSuccess({
                data: data,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommerceTaxSettingsAction.LoadEcommerceTaxSettingsFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
